export default __webpack_public_path__ + "static/media/screenBlock20.92de9ca8.jpg";